import SvgAppleIcon from './svgs/AppleIcon.js';
import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import { useIcon } from '../../shared-components/icon/index.js';

var appleIcon = (props => useIcon(SvgAppleIcon, SvgAppleIcon, props));

export { appleIcon as default };
